// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// Small shared presentational helpers used across the Carbon screens.

import React from 'react';
import type { Severity } from '../../types/alarm';

/** Colored severity tag (P1..P4) matching the mock's sevTag. */
export function SevTag({ sev, label }: { sev: Severity; label?: string }) {
  return (
    <span className={`hs-sev hs-sev-${sev}`}>
      <span className="dot" />
      {label ?? sev}
    </span>
  );
}

/** Page header with title + optional right-side actions and a date line. */
export function PageHead({
  title,
  dateline,
  actions,
}: {
  title: string;
  dateline?: string;
  actions?: React.ReactNode;
}) {
  return (
    <>
      <div className="hs-page-head">
        <h1 className="hs-title">{title}</h1>
        {actions && <div style={{ display: 'flex', gap: 8 }}>{actions}</div>}
      </div>
      {dateline && <div className="hs-dateline">{dateline}</div>}
    </>
  );
}

/** Generic empty state. */
export function EmptyState({ big, sub }: { big: string; sub?: string }) {
  return (
    <div className="hs-empty">
      <div className="big">{big}</div>
      {sub && <div>{sub}</div>}
    </div>
  );
}

/** Loading placeholder. */
export function Loading({ label = 'Loading…' }: { label?: string }) {
  return <div className="hs-loading">{label}</div>;
}

/** Diagnosis / Helios "sparkle" tag. */
export function DxTag({ children }: { children: React.ReactNode }) {
  return (
    <span className="hs-diag-tag">
      <span aria-hidden>✦</span>
      {children}
    </span>
  );
}
